import { createSlice } from "@reduxjs/toolkit";

type CommodityAccessMap = {
  [commodity: string]: boolean;
};

type DISABLESCREENS = {
  [key: string]: boolean | CommodityAccessMap;
};

const initialState: DISABLESCREENS = {
  boardCost: true,
  quoteUpload: true,
  allocationSummary: true,
  vendorQuoteAssesment: true,
  volumeAllocation: true,
};

const filterSlice = createSlice({
  name: "disableScreens",
  initialState,
  reducers: {
    updateScreenAccess(state: DISABLESCREENS, action) {
      return {
        ...initialState,
        ...action.payload,
      };
    },
  },
});

export const { updateScreenAccess } = filterSlice.actions;
export default filterSlice.reducer;
